module.exports = __webpack_public_path__ + "2-41.jpg?917ccd87766d160f88f722b3ec65d522";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-41.jpg
// module id = 118
// module chunks = 0